module.exports = __webpack_public_path__ + "static/img/anB_3.9431d17.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/anB_3.png
// module id = 1250
// module chunks = 1